
import { Component, Emit, Vue, Prop } from 'vue-property-decorator'
import AppBox from '@/components/AppBox.vue'
import AppButton from '@/components/AppButton.vue'
import AppContainer from '@/components/AppContainer.vue'
import HomeAppItemBrand from '@/components/HomeAppItemBrand.vue'
import CommonAppItemPlatform from '@/components/CommonAppItemPlatform.vue'
import { formatDate } from '@/utils/date'

@Component({
    components: {
        AppBox,
        AppButton,
        AppContainer,
        HomeAppItemBrand,
        CommonAppItemPlatform,
    },
})
export default class HomeAppItemAccount extends Vue {
    @Prop() private app!: AppEntity

    get hasAccount(): boolean {
        return this.app.iOS !== undefined && this.app.account !== undefined
    }

    get isITCapitalAccount(): boolean {
        if (
            this.app.iOS &&
            this.app.account &&
            this.app.account.email &&
            this.app.account.email === 'mcmanaus@deliverydireto.com.br' &&
            this.app.account.teamId === 'R42JWGJHWT'
        ) {
            return true
        }
        return false
    }

    get accountType() {
        if (
            this.app.iOS &&
            this.app.account &&
            this.app.account.type
        ) {
            return this.app.account.type
        }
        return null
    }

    get isWebviewIOS(): boolean {
        return this.app.brand.settings.webviewVersion
    }

    get isWebviewAndroid(): boolean {
        return this.app.brand.settings.webviewVersionAndroid
    }

    get name() {
        if (
            this.app.iOS &&
            this.app.account &&
            this.app.account.teamName
        ) {
            return this.app.account.teamName
        }
        return null
    }

    get teamId() {
        if (
            this.app.iOS &&
            this.app.account &&
            this.app.account.teamId
        ) {
            return this.app.account.teamId
        }
        return null
    }

    get email() {
        if (
            this.app.iOS &&
            this.app.account &&
            this.app.account.email
        ) {
            return this.app.account.email
        }
        return null
    }

    get password() {
        if (
            this.app.iOS &&
            this.app.account &&
            this.app.account.password
        ) {
            return this.app.account.password
        }
        return null
    }

    get phoneNumber() {
        if (
            this.app.iOS &&
            this.app.account &&
            this.app.account.phoneNumber
        ) {
            return this.app.account.phoneNumber
        }
        return null
    }

    get developerProgramRegisteredAt() {
        if (this.app.account?.developerProgramRegisteredAt) {
            return formatDate(
                this.app.account.developerProgramRegisteredAt,
            )
        }
        return null
    }
}
